<template>
    <div>
        <!-- <b-card
            title="Información básica"
            tag="article"
            style="max-width: 100%;"
            class="mb-2"
        > -->
        <!-- <div class="card-text"> -->
        <b-row wrap align-v="center">
            <b-col cols="12" md="6" lg="8">
                <app-form-text-input
                    label="Motivo"
                    id="purpose"
                    v-model="theReport.purpose"
                    :required="true"
                    :hasError="$v.theReport.purpose.$error"
                    errorMessage="Debe escribir el motivo de la reunión"
                    @input="$v.theReport.purpose.$touch()"
                    @blur="saveDraft"
                />
            </b-col>
            <b-col cols="12" md="6" lg="4" v-if="!!savedAt">
                Guardado el: {{ savedAt }}
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6" lg="6">
                <b-form-row>
                    <b-col cols="12" lg="8">
                        <app-datepicker-native
                            id="meetingDate"
                            label="Fecha de reunión"
                            v-model="theReport.meetingDate"
                            :auto="true"
                            min-date="-1W"
                            max-date="0"
                            @change="saveDraft"
                        />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <app-timepicker-native
                            size="sm"
                            label-close-button="Cerrar"
                            label-no-time-selected="Seleccione la hora"
                            label="Hora reunión"
                            :auto="true"
                            v-model="theReport.meetingTime"
                            @input="saveDraft"
                        />
                    </b-col>
                </b-form-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6">
                <app-form-textarea-input
                    label="Descripción de la reunión"
                    id="name"
                    v-model="theReport.meetingDescription"
                    @blur="saveDraft"
                />
            </b-col>
            <b-col cols="12" md="6">
                <app-form-textarea-input
                    label="Notas internas"
                    id="internalNotes"
                    v-model="theReport.internalNotes"
                    @blur="saveDraft"
                />
            </b-col>
        </b-row>
        <h6>Contactos del cliente</h6>
        <b-row>
            <b-col cols="12" md="3" v-for="(contact, i) in contacts" :key="i">
                <b-btn
                    size="sm"
                    variant="primary"
                    :disabled="isContactSelected(contact.id)"
                    @click="addContact(contact)"
                    ><i class="fa fa-plus" aria-hidden="true"></i>
                    {{ contact.first_name }}
                    {{ contact.last_name }}</b-btn
                >
            </b-col>
        </b-row>
        <b-card>
            <div class="card-text">
                <b-row>
                    <b-col cols="12" md="3">
                        <app-form-text-input
                            placeholder="Nombre participante"
                            id="participantName"
                            v-model="theParticipant.name"
                            :required="true"
                            :hasError="$v.theParticipant.name.$error"
                            errorMessage="Debe escribir el nombre del participante"
                            @input="$v.theParticipant.name.$touch()"
                        />
                    </b-col>
                    <b-col cols="12" md="2">
                        <app-form-text-input
                            placeholder="Rol"
                            id="rol"
                            v-model="theParticipant.position"
                        />
                    </b-col>
                    <b-col cols="12" md="3">
                        <app-form-text-input
                            placeholder="Email"
                            id="participantEmail"
                            v-model="theParticipant.email"
                            :hasError="$v.theParticipant.email.$error"
                            errorMessage="E-mail incorrecto"
                            @input="$v.theParticipant.email.$touch()"
                        />
                    </b-col>
                    <b-col cols="12" md="2">
                        <app-form-text-input
                            placeholder="Teléfono"
                            id="participantPhone"
                            v-model="theParticipant.phone"
                        />
                    </b-col>
                    <b-col cols="12" md="2">
                        <b-btn
                            size="sm"
                            variant="primary"
                            class="btn-block-xs-only"
                            @click="addParticipant"
                            ><i class="fa fa-plus" aria-hidden="true"></i>
                            Agregar participante</b-btn
                        >
                    </b-col>
                </b-row>
            </div>
        </b-card>
        <br />
        <b-row v-if="theReport.participants.length">
            <h5>Lista de participantes</h5>
            <b-col cols="12">
                <div class="table-responsive">
                    <table class="table table-hover table-bordered table-sm">
                        <thead class="thead-orange">
                            <tr>
                                <th>Nombre</th>
                                <th>Rol</th>
                                <th>E-mail</th>
                                <th>Teléfono</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(participant,
                                i) in theReport.participants"
                                class="x-d-flex"
                                :key="i"
                            >
                                <template v-if="!!participant.editing">
                                    <td>
                                        <app-form-text-input
                                            placeholder="Nombre participante"
                                            id="participantName2"
                                            v-model="selectedParticipant.name"
                                            :required="true"
                                            :hasError="
                                                $v.selectedParticipant.name
                                                    .$error
                                            "
                                            errorMessage="Debe escribir el nombre del participante"
                                            @input="
                                                $v.selectedParticipant.name.$touch()
                                            "
                                        />
                                    </td>
                                    <td>
                                        <app-form-text-input
                                            placeholder="Rol"
                                            id="rol2"
                                            v-model="
                                                selectedParticipant.position
                                            "
                                        />
                                    </td>
                                    <td>
                                        <app-form-text-input
                                            placeholder="Email"
                                            id="participantEmail2"
                                            v-model="selectedParticipant.email"
                                            :hasError="
                                                $v.selectedParticipant.email
                                                    .$error
                                            "
                                            errorMessage="E-mail incorrecto"
                                            @input="
                                                $v.selectedParticipant.email.$touch()
                                            "
                                        />
                                    </td>
                                    <td>
                                        <app-form-text-input
                                            placeholder="Teléfono"
                                            id="participantPhone2"
                                            v-model="selectedParticipant.phone"
                                        />
                                    </td>
                                    <td>
                                        <b-btn
                                            size="sm"
                                            variant="danger"
                                            @click="
                                                editParticipant(
                                                    participant,
                                                    false
                                                )
                                            "
                                            ><i
                                                class="fa fa-times"
                                                aria-hidden="true"
                                            ></i
                                        ></b-btn>
                                        <b-btn
                                            size="sm"
                                            variant="success"
                                            @click="confirmEdition"
                                            ><i
                                                class="fa fa-check"
                                                aria-hidden="true"
                                            ></i
                                        ></b-btn>
                                    </td>
                                </template>
                                <template v-else>
                                    <td>{{ participant.name }}</td>
                                    <td>{{ participant.position }}</td>
                                    <td>{{ participant.email }}</td>
                                    <td>{{ participant.phone }}</td>
                                    <td>
                                        <b-btn
                                            size="sm"
                                            variant="info"
                                            @click="
                                                editParticipant(
                                                    participant,
                                                    true
                                                )
                                            "
                                            ><i
                                                class="fa fa-pencil"
                                                aria-hidden="true"
                                            ></i
                                        ></b-btn>
                                        <b-btn
                                            size="sm"
                                            class="ml-2"
                                            variant="danger"
                                            @click="
                                                removeParticipant(participant)
                                            "
                                            ><i
                                                class="fa fa-times"
                                                aria-hidden="true"
                                            ></i
                                        ></b-btn>
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-col>
        </b-row>
        <b-card
            title="Compromisos de la reunión"
            tag="article"
            style="max-width: 100%;"
            class="mb-2"
        >
            <div class="card-text">
                <b-row>
                    <b-col cols="12" md="3">
                        <app-form-select-input
                            label="Seleccione tipo de compromiso"
                            :options="petitionTypes"
                            v-model="petition.petition_type"
                            :is-object="true"
                        />
                    </b-col>
                    <b-col cols="12" md="9">
                        <app-form-textarea-input
                            label="Descripción del compromiso"
                            id="description"
                            v-model="petition.description"
                            rows="2"
                        />
                    </b-col>
                    <b-col cols="12">
                        <div class="d-flex justify-content-end">
                            <b-btn
                                variant="primary"
                                size="sm"
                                class="btn-block-xs-only"
                                @click="addPetition"
                                ><i class="fa fa-plus" aria-hidden="true"></i>
                                Agregar compromiso</b-btn
                            >
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div v-if="theReport.petitions.length">
                            <h5>Lista de compromisos</h5>
                            <div
                                v-for="petition in theReport.petitions"
                                :key="petition.id"
                            >
                                <b-row>
                                    <b-col>
                                        <label
                                            >({{ petition.petition_type.name }})
                                            {{ petition.description }}
                                        </label>
                                    </b-col>
                                    <b-col>
                                        <b-btn
                                            size="sm"
                                            variant="danger"
                                            @click="removePetition(petition)"
                                            ><i
                                                class="fa fa-times"
                                                aria-hidden="true"
                                            ></i
                                        ></b-btn>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-card>
        <b-card
            title="Asignar tarea a la reunión"
            tag="article"
            style="max-width: 100%;"
            class="mb-2"
        >
            <div class="card-text">
                <b-row>
                    <b-col cols="12" md="6" lg="4">
                        <b-btn
                            size="sm"
                            variant="primary"
                            @click="openPopupAddTask"
                        >
                            <i class="fa fa-plus" aria-hidden="true"></i>
                            Agregar Tarea</b-btn
                        >
                    </b-col>
                    <b-col cols="12" v-if="contactReportTasks.length > 0">
                        <b>Lista de Tareas:</b>
                        <div class="table-responsive-sm">
                            <table
                                class="table table-hover table-bordered table-sm"
                            >
                                <thead class="thead-orange">
                                    <tr class="x-d-flex">
                                        <th>Tarea</th>
                                        <th>Descripcion</th>
                                        <th>Asignado a</th>
                                        <th>Fecha de vencimiento</th>
                                        <th>Accion</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="task in contactReportTasks"
                                        :key="task.id"
                                    >
                                        <td>
                                            {{ task.name }}
                                        </td>
                                        <td>
                                            {{ task.description }}
                                        </td>
                                        <td>
                                            {{ task.assignee.name }}
                                        </td>
                                        <td>
                                            {{ task.due_date | date }}
                                        </td>
                                        <td>
                                            <b-btn
                                                variant="danger"
                                                size="sm"
                                                @click="onDeleteTask(task.id)"
                                                :disabled="inProgress"
                                                ><i class="fa fa-trash"></i
                                            ></b-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-col>
                    <span v-else>
                        No hay tareas creadas
                    </span>
                </b-row>
            </div>
        </b-card>
        <b-row class="justify-content-center">
            <b-col cols="12" md="6" lg="4">
                <b-card
                    v-if="isSave"
                    tag="article"
                    style="max-width: 100%;"
                    class="mb-2"
                >
                    <div class="card-text">
                        <app-upload-or-take-photo
                            id="report-photos"
                            title="Fotos de la reunión"
                            v-model="files"
                        />
                        <div v-if="files">
                            <button
                                class="btn btn-sm btn-danger pull-right"
                                @click="cancelFilesSelected"
                            >
                                <i class="fa fa-trash-o" aria-hidden="true"></i>
                                Cancelar archivos seleccionados
                            </button>
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <!-- </div> -->

        <br />
        <b-row>
            <b-col class="d-flex justify-content-end">
                <b-button
                    :disabled="inProgress"
                    class="btn-block-xs-only mr-3"
                    @click="saveDraft"
                    variant="confirm"
                    ><i class="fa fa-save"></i> Guardar</b-button
                >

                <b-button
                    :disabled="inProgress"
                    class="btn-block-xs-only"
                    @click="confirmationMessage"
                    variant="confirm"
                    ><i class="fa fa-check"></i> Terminar reunión</b-button
                >
            </b-col>
        </b-row>
        <!-- </b-card> -->

        <!-- Ventana de confirmación de cierre de reunión con el cliente -->
        <app-pop-up title="Confirmación" id="confirmation-message" size="large">
            <div slot="body">
                <b-row>
                    <b-col cols="12" md="12">
                        <b>Motivo:</b> <label>{{ theReport.purpose }}</label>
                    </b-col>
                    <b-col cols="12" md="12">
                        <b>Descripción de la reunión:</b>
                        <label>{{ theReport.meetingDescription }}</label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col v-if="!theReport.participants.length">
                        <b>Lista de participantes:</b>
                        <label
                            >No hay participantes agregados a esta
                            reunión</label
                        >
                    </b-col>
                    <b-col cols="12" v-if="theReport.participants.length">
                        <b>Lista de participantes:</b>
                        <div class="table-responsive-sm">
                            <table
                                class="table table-hover table-bordered table-sm"
                            >
                                <thead class="thead-orange">
                                    <tr class="x-d-flex">
                                        <th>Nombre</th>
                                        <th>Rol</th>
                                        <th>E-mail</th>
                                        <th>Teléfono</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(participant,
                                        i) in theReport.participants"
                                        :key="i"
                                    >
                                        <td>{{ participant.name }}</td>

                                        <td>{{ participant.position }}</td>
                                        <td>{{ participant.email }}</td>
                                        <td>{{ participant.phone }}</td>
                                        <td>
                                            <b-form-checkbox
                                                v-model="participant.sendEmail"
                                                v-if="!!participant.email"
                                            >
                                                Enviar Acta de Reunión
                                            </b-form-checkbox>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-btn v-b-toggle.collapse1 size="sm" variant="primary"
                            >Agregar destinatarios</b-btn
                        >
                        <b-collapse id="collapse1" class="mt-2">
                            <b-card>
                                <h6>
                                    Seleccione con quien desea compartir la
                                    reunión
                                </h6>
                                <b-row>
                                    <b-col cols="10">
                                        <app-autocomplete
                                            placeholder="Administrativos"
                                            :items="watchers"
                                            v-model="watcher"
                                            results-prop="namePosition"
                                        />
                                    </b-col>
                                    <b-col cols="1">
                                        <b-btn
                                            variant="primary"
                                            @click="addWatcher"
                                            ><i
                                                class="fa fa-plus"
                                                aria-hidden="true"
                                            ></i
                                        ></b-btn>
                                    </b-col>
                                </b-row>
                                <div v-if="theReport.watchers.length">
                                    <h5>Lista de destinatarios</h5>
                                    <div
                                        v-for="watcher in theReport.watchers"
                                        :key="watcher.id"
                                    >
                                        <b-row>
                                            <b-col cols="10">
                                                <label
                                                    >- {{ watcher.name }} ({{
                                                        watcher.position.name
                                                    }})
                                                </label>
                                            </b-col>
                                            <b-col cols="2">
                                                <b-btn
                                                    size="sm"
                                                    variant="danger"
                                                    @click="
                                                        removeWatcher(watcher)
                                                    "
                                                    ><i
                                                        class="fa fa-times"
                                                        aria-hidden="true"
                                                    ></i
                                                ></b-btn>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </div>
                            </b-card>
                        </b-collapse>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col v-if="!theReport.petitions.length">
                        <b>Lista de compromisos:</b>
                        <label
                            >No hay compromisos agregados a esta reunión</label
                        >
                    </b-col>
                    <b-col cols="12" v-if="theReport.petitions.length">
                        <b>Lista de compromisos:</b>
                        <div class="table-responsive-sm">
                            <table
                                class="table table-hover table-bordered table-striped"
                            >
                                <thead>
                                    <tr class="x-d-flex">
                                        <th>Tipo</th>
                                        <th>Descripción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(petition,
                                        i) in theReport.petitions"
                                        class="x-d-flex"
                                        :key="i"
                                    >
                                        <td>
                                            {{ petition.petition_type.name }}
                                        </td>
                                        <td>{{ petition.description }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-col>
                    <b-col cols="12" v-if="contactReportTasks.length > 0">
                        <b>Lista de Tareas:</b>
                        <div class="table-responsive-sm">
                            <table
                                class="table table-hover table-bordered table-sm"
                            >
                                <thead class="thead-orange">
                                    <tr class="x-d-flex">
                                        <th>Tarea</th>
                                        <th>Descripcion</th>
                                        <th>Asignado a</th>
                                        <th>Fecha de vencimiento</th>
                                        <th>Accion</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="task in contactReportTasks"
                                        :key="task.id"
                                    >
                                        <td>
                                            {{ task.name }}
                                        </td>
                                        <td>
                                            {{ task.description }}
                                        </td>
                                        <td>
                                            {{ task.assignee.name }}
                                        </td>
                                        <td>
                                            {{ task.due_date | date }}
                                        </td>
                                        <td>
                                            <b-btn
                                                variant="danger"
                                                size="sm"
                                                :disabled="inProgress"
                                                @click="onDeleteTask(task.id)"
                                                ><i class="fa fa-trash"></i>
                                            </b-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-col>
                </b-row>
                <b-form-checkbox
                    v-model="addSatisfactionPoll"
                    v-if="userCan('encuesta-de-satisfaccion')"
                >
                    Agregar encuesta de satisfacción
                </b-form-checkbox>
                <b-form-checkbox v-model="customerConfirmation">
                    Estoy de acuerdo con la información
                </b-form-checkbox>
            </div>
            <div class="buttons" slot="buttons">
                <b-button
                    :disabled="
                        !customerConfirmation
                            ? !customerConfirmation
                            : inProgress
                    "
                    class="btn-block-xs-only"
                    @click="finishReport"
                    variant="confirm"
                    ><i class="fa fa-check"></i> Terminar reunión</b-button
                >
            </div>
        </app-pop-up>

        <app-pop-up
            size="large"
            :onClose="cleanSatisfactionPoll"
            title="Encuesta de satisfacción"
            id="satisfaction-poll"
        >
            <div slot="body">
                <app-satisfaction-poll-form
                    v-if="theReport"
                    :onSave="onSaveSatisfactionPoll"
                    :theClientId="clientId"
                    :theReportId="theReport.id"
                />
            </div>
            <div class="buttons" slot="buttons">
                <b-button
                    variant="confirm"
                    :disabled="inProgress"
                    class="btn-block-xs-only"
                    @click="$bus.$emit('satisfaction-poll.save')"
                    ><i class="fa fa-floppy-o"></i> Guardar encuesta</b-button
                >
            </div>
        </app-pop-up>

        <app-pop-up
            title="Agregar Tarea"
            id="contact-report-task-window"
            size="large"
        >
            <div class="form" slot="body">
                <app-contact-report-task-form
                    ref="task-form"
                    @task-added="onTaskAdded"
                    :contact-report-id="contactReportId"
                ></app-contact-report-task-form>
            </div>
            <div slot="buttons">
                <!-- <button class="btn btn-confirm" :disabled="inProgress" @click="$bus.$emit('add-contact-report-task.save');"> Asignar</button> -->
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="$refs['task-form'].addTask()"
                >
                    Asignar
                </button>
            </div>
        </app-pop-up>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import contactsRepository from '../../../../../repositories/contacts.repository.js'
import petitionsRepository from '../../../../../repositories/petitions.repository.js'
import usersRepository from '../../../../../repositories/users.repository.js'
import UploadOrTakePhoto from '../../../../UI/Controls/Photos/UploadOrTakePhoto.vue'
import Autocomplete from '../../../../UI/Controls/AutocompleteV2/Autocomplete.vue'
import DatePicker from '../../../../UI/Controls/DatePicker/DatePicker.vue'
import TimePicker from '../../../../UI/Controls/TimePicker/TimePicker'
import SatisfactionPollForm from '../SatisfactionPoll/SatisfactionPollForm/SatisfactionPollForm.vue'
import ContactReportTaskForm from './ContactReportTaskForm/ContactReportTaskForm'

const uniqueEmail = function(email) {
    return !this.theReport.participants.find(
        item => item.email === email && !item.editing
    )
}

export default {
    components: {
        appUploadOrTakePhoto: UploadOrTakePhoto,
        appAutocomplete: Autocomplete,
        appDatepicker: DatePicker,
        appTimePicker: TimePicker,
        appSatisfactionPollForm: SatisfactionPollForm,
        appContactReportTaskForm: ContactReportTaskForm,
    },

    props: {
        report: {
            type: Object,
        },
        isSave: {
            type: Boolean,
            default: true,
        },
        clientId: {
            required: true,
        },
        redirect: {
            type: String,
            default: 'clientContactsPage',
        },
    },

    data() {
        return {
            theReport: {
                id: 0,
                clientId: '',
                reportedById: '',
                meetingDescription: '',
                participants: [],
                petitions: [],
                purpose: '',
                internalNotes: '',
                meetingDate: '',
                meetingTime: '',
                watchers: [],
            },
            theParticipant: {
                name: '',
                position: '',
                phone: '',
                email: '',
                sendEmail: 0,
            },
            selectedParticipant: {
                name: '',
                position: '',
                phone: '',
                email: '',
            },
            petition: {},
            petitionTypes: [],
            contacts: [],
            customerConfirmation: false,
            addSatisfactionPoll: false,
            files: '',
            watcher: '',
            watchers: [],
            savedAt: '',
            taskObject: '',
            contactReportTasks: [],
        }
    },
    watch: {
        ['theReport.meetingDate'](val) {
            console.log(val + ' en el watcher')
        },
    },
    validations() {
        if (this.inEdition) {
            return {
                selectedParticipant: {
                    name: { required },
                    email: { email, uniqueEmail },
                },
                theReport: {
                    purpose: { required },
                },
                theParticipant: {
                    name: {},
                    email: {},
                },
            }
        } else {
            return {
                theReport: {
                    purpose: { required },
                },
                theParticipant: {
                    name: { required },
                    email: !!this.theParticipant.email.length
                        ? { email, uniqueEmail }
                        : {},
                },
                selectedParticipant: {
                    name: {},
                    email: {},
                },
            }
        }
    },
    computed: {
        inEdition() {
            return !!this.theReport.participants.filter(item => !!item.editing)
                .length
        },
        contactReportId() {
            return this.theReport ? this.theReport.id : this.report.id || null
        },
    },
    methods: {
        async onDeleteTask(id) {
            const { data } = await repo.delete(`tasks/${id}`)
            if (data.status) {
                toastr.success(data.msg)
                this.loadContactReportTask(this.theReport.id)
            } else {
                toastr.error(data.msg)
            }
        },
        async loadContactReportTask(id) {
            const { data } = await repo.delete(`contacts/report-tasks/${id}`)
            if (data.status) {
                this.contactReportTasks = []
                this.contactReportTasks = data.data
            } else {
                toastr.error(data.msg)
            }
        },
        onTaskAdded(task) {
            this.contactReportTasks.push(task)
            this.$bus.$emit('contact-report-task-window.close')
        },
        openPopupAddTask() {
            this.$bus.$emit('contact-report-task-window.open')
            this.$refs['task-form'].cleanForm()
            //this.$bus.$emit("clear-data-contact-report-task-form");
        },
        closePopupAddTask() {
            this.$bus.$emit('task-contact-report-form-window.close')
        },
        confirmEdition() {
            const index = this.theReport.participants.findIndex(
                item => item.email === this.selectedParticipant.originalEmail
            )

            if (-1 !== index) {
                this.theReport.participants.splice(index, 1, {
                    ...this.selectedParticipant,
                    editing: false,
                })
                Object.keys(this.selectedParticipant).map(
                    key => (this.selectedParticipant[key] = '')
                )
            }
            this.saveDraft()
        },
        editParticipant(participant, state) {
            const part = { ...participant, editing: state }
            const index = this.theReport.participants.findIndex(
                item => item.email === participant.email
            )

            if (-1 !== index) {
                this.theReport.participants.splice(index, 1, part)
                this.selectedParticipant = {
                    ...participant,
                    originalEmail: participant.email,
                }
            }
        },
        isContactSelected(contactId) {
            return !!this.theReport.participants.find(
                item => item.id === contactId
            )
        },
        confirmationMessage() {
            this.$v.theReport.$touch()
            if (this.$v.theReport.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            this.saveDraft()

            this.$bus.$emit('confirmation-message.open')
        },
        saveDraft() {
            if (!this.theReport.id) {
                this.createDraft()
            } else {
                this.updateDraft()
            }
            this.savedAt = moment().format('DD/MM/YYYY HH:mm:ss')
        },
        async createDraft() {
            this.$v.theReport.$touch()
            if (this.$v.theReport.$invalid) {
                //toastr.error('Debe diligenciar correctamente todos los campos obligatorios');
                return false
            }

            if (this.inEdition) {
                toastr.error(
                    'Hay participantes que se estan editando, confirme la información para continuar'
                )
                return false
            }
            this.startProcessing()

            const formData = new FormData()

            formData.append('internalNotes', this.theReport.internalNotes)
            formData.append('purpose', this.theReport.purpose)
            formData.append('meetingDate', this.theReport.meetingDate)
            formData.append(
                'meetingTime',
                !!this.theReport.meetingTime
                    ? this.theReport.meetingTime
                    : '00:00:00'
            )
            formData.append(
                'meetingDescription',
                this.theReport.meetingDescription
            )
            formData.append('clientId', this.clientId)
            formData.append('reportedById', this.user.id)

            this.theReport.watchers.map(item => {
                formData.append('watchers[watchers][]', item.id)
            })

            if (!!this.theReport.participants.length) {
                this.theReport.participants.forEach((item, index) => {
                    Object.keys(item).forEach(key =>
                        formData.append(
                            `participants[${index}][${key}]`,
                            item[key]
                        )
                    )
                })
            }

            if (!!this.theReport.petitions.length) {
                this.theReport.petitions.forEach((item, index) => {
                    Object.keys(item).forEach(key =>
                        formData.append(
                            `petitions[${index}][${key}]`,
                            item[key]
                        )
                    )
                    formData.append(
                        `petitions[${index}][petitionTypeId]`,
                        item.petition_type.id
                    )
                })
            }

            if (this.files.photos) {
                this.files.photos.map(item => formData.append('photos[]', item))
            }
            if (this.files.files) {
                this.files.files.map((item, index) =>
                    formData.append('file' + index, item)
                )
            }

            const { data } = await repo.post('contacts/reports', formData)
            if (data.status) {
                this.stopProcessing()
                this.theReport.id = data.contactReport.id
                toastr.success(data.msg)
            } else {
                this.stopProcessing()
                toastr.error(data.msg)
            }
        },
        async updateDraft() {
            this.$v.theReport.$touch()
            if (this.$v.theReport.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            if (this.inEdition) {
                toastr.error(
                    'Hay participantes que se estan editando, confirme la información para continuar'
                )
                return false
            }
            this.startProcessing()

            const formData = new FormData()
            Object.keys(this.theReport).map(
                key =>
                    !['participants', 'petitions'].includes(key) &&
                    formData.append(key, this.theReport[key])
            )

            this.theReport.participants.map((participant, index) =>
                Object.keys(participant).map(key =>
                    formData.append(
                        `participants[${index}][${key}]`,
                        participant[key]
                    )
                )
            )
            this.theReport.petitions.map((petition, index) => {
                Object.keys(petition).map(
                    key =>
                        !['petition_type'].includes(key) &&
                        formData.append(
                            `petitions[${index}][${key}]`,
                            petition[key]
                        )
                )
                formData.append(
                    `petitions[${index}][petition_type][id]`,
                    petition.petition_type.id
                )
            })

            const meetingTime = !!this.theReport.meetingTime
                ? this.theReport.meetingTime
                : '00:00:00'

            formData.append('meetingTime', meetingTime)
            formData.append('taskObject', this.taskObject)

            this.files?.photos &&
                this.files.photos.map(photo =>
                    formData.append('photos[]', photo)
                )

            this.files?.files &&
                this.files.files.map(file => formData.append('files[]', file))

            formData.append('_method', 'PUT')

            // const payload = {
            //     ...this.theReport,
            //     meetingTime: !!this.theReport.meetingTime
            //         ? this.theReport.meetingTime
            //         : '00:00:00',
            //     taskObject: this.taskObject,
            // }

            const { data } = await repo.post(
                `contacts/reports/${this.theReport.id}`,
                formData
            )

            if (data.status) {
                this.stopProcessing()
            } else {
                this.stopProcessing()
                toastr.error('Error al actualizar el reporte de la reunión')
            }
        },
        async finishReport() {
            this.$v.theReport.$touch()
            if (this.$v.theReport.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }
            if (this.inEdition) {
                toastr.error(
                    'Hay participantes que se estan editando, confirme la información para continuar'
                )
                return false
            }
            this.startProcessing()

            // const payload = {
            //     clientId: this.clientId,
            //     watchers: this.theReport.watchers,
            //     participants: this.theReport.participants,
            //     photos: this.files.photos,
            //     files: this.files.files,
            // }

            const formData = new FormData()
            formData.append('clientId', this.clientId)

            Object.keys(this.theReport).map(
                key =>
                    ![
                        'participants',
                        'petitions',
                        'watchers',
                        'clientId',
                    ].includes(key) && formData.append(key, this.theReport[key])
            )

            this.theReport.participants.map((participant, index) =>
                Object.keys(participant).map(key =>
                    formData.append(
                        `participants[${index}][${key}]`,
                        participant[key]
                    )
                )
            )
            this.theReport.watchers.map((watcher, index) =>
                Object.keys(watcher).map(key =>
                    formData.append(`watchers[${index}][${key}]`, watcher[key])
                )
            )
            this.theReport.petitions.map((petition, index) =>
                Object.keys(petition).map(key => {
                    !['petition_type'].includes(key) &&
                        formData.append(
                            `petitions[${index}][${key}]`,
                            petition[key]
                        )
                    formData.append(
                        `petitions[${index}][petition_type]['id']`,
                        petition.petition_type.id
                    )
                })
            )

            const meetingTime = !!this.theReport.meetingTime
                ? this.theReport.meetingTime
                : '00:00:00'

            formData.append('meetingTime', meetingTime)
            formData.append('taskObject', this.taskObject)

            this.files?.photos &&
                this.files.photos.map(photo =>
                    formData.append('photos[]', photo)
                )

            this.files?.files &&
                this.files.files.map(file => formData.append('files[]', file))

            if (this.geolocation) {
                const { latitude, longitude } = await getCurrentPosition()
                formData.latitude = latitude
                formData.longitude = longitude
            }

            formData.append('_method', 'PUT')

            const cr = { ...contactsRepository }
            cr.finishReport(formData, this.theReport.id)
                .then(data => {
                    this.stopProcessing()

                    if (!data.status)
                        return toastr.error(
                            `Ocurrió un error finalizando la reunión [${data.msg}]`
                        )

                    toastr.success(data.msg)
                    if (this.addSatisfactionPoll) {
                        this.answerPoll()
                    } else {
                        this.$bus.$emit('confirmation-message.close')
                        this.$router.push({
                            name: this.redirect,
                            params: { clientId: this.clientId },
                        })
                    }
                })
                .catch(error => {
                    this.stopProcessing()
                    toastr.error('Error al finalizar el reporte de la reunión')
                })
        },
        fillForm() {
            if (_.isEmpty(this.report)) return

            this.contactReportTasks = []
            const meetingDate = moment(this.report.meeting_date)
            this.theReport.id = this.report.id
            this.theReport.purpose = this.report.purpose
            this.theReport.meetingDate = meetingDate.format('YYYY-MM-DD')
            this.theReport.meetingTime = meetingDate.format('HH:mm:ss')
            this.theReport.meetingDescription = this.report.meeting_description
            this.theReport.petitions = this.report.petition_drafts
            this.theReport.participants = this.report.participants
            this.theReport.internalNotes = this.report.internal_notes
            this.contactReportTasks = this.report.tasks
        },
        addParticipant() {
            this.$v.theParticipant.$touch()
            if (this.$v.theParticipant.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            if (this.theParticipant) {
                this.theParticipant.isContact = false
                this.theParticipant.sendEmail = 0
                this.theReport.participants.push({
                    id: 0,
                    ...this.theParticipant,
                })
                Object.keys(this.theParticipant).map(
                    key => (this.theParticipant[key] = '')
                )
                this.$v.$reset()

                this.saveDraft()
            } else {
                toastr.error('Ingrese el nombre del participante')
            }
        },
        addContact(contact) {
            const participant = {}
            participant.id = contact.id
            participant.name = contact.first_name + ' ' + contact.last_name
            participant.position = contact.position
            participant.email = !!contact.email ? contact.email : ''
            participant.sendEmail = false
            !!contact.phone_primary
                ? (participant.phone = contact.phone_primary)
                : (participant.phone = '')
            participant.idContact = contact.id
            participant.isContact = true
            this.theReport.participants.push(participant)

            this.saveDraft()

            contact.disabled = true
        },
        removeParticipant(participant) {
            const i = this.theReport.participants.indexOf(participant)
            this.theReport.participants.splice(i, 1)
            toastr.success('Participante eliminado')
            this.saveDraft()
        },
        loadPetitionTypes() {
            const pr = { ...petitionsRepository }
            pr.loadPetitionTypes()
                .then(data => {
                    this.petitionTypes = data
                })
                .catch(error =>
                    toastr.error('No se pudo cargar los tipos de compromiso')
                )
        },
        loadContacts() {
            const cr = { ...contactsRepository }
            const filters = { clientId: this.clientId } //se cargan solo los contactos del cliente
            cr.getContacts(filters)
                .then(data => {
                    this.contacts = data
                    this.contacts.map(key => (key.disabled = false))
                })
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cargar los contactos del cliente'
                    )
                )
        },
        loadWatchers() {
            const ur = { ...usersRepository }
            ur.getAdministrativeUsers()
                .then(data => {
                    data.map(item => {
                        const administrativeUser = {
                            ...item,
                            namePosition:
                                item.name + ' (' + item.position.name + ')',
                        }
                        this.watchers.push(administrativeUser)
                    })
                })
                .catch(error => {
                    toastr.error('No se pudo cargar los administrativos')
                })
        },
        addPetition() {
            if (this.petition.petition_type && this.petition.description) {
                this.petition.client_id = this.clientId
                this.petition.user_id = this.user.id
                this.theReport.petitions.push(this.petition)
                this.petition = {}
                this.saveDraft()
            } else {
                toastr.error('Ingrese los campos del compromiso')
            }
        },
        removePetition(petition) {
            const i = this.theReport.petitions.indexOf(petition)
            this.theReport.petitions.splice(i, 1)
            toastr.success('Compromiso eliminado')
            this.saveDraft()
        },
        cancelFilesSelected() {
            this.$bus.$emit('report-photos.clean')
            this.files = ''
            toastr.success('Archivos cancelados')
        },
        addWatcher() {
            if (this.watcher) {
                this.theReport.watchers.push(this.watcher)
                this.watcher = ''
                this.saveDraft()
            } else {
                toastr.error('Ingrese el nombre del observador')
            }
        },
        removeWatcher(watcher) {
            const i = this.theReport.watchers.indexOf(watcher)
            this.theReport.watchers.splice(i, 1)
            toastr.success('Observador eliminado')
            this.saveDraft()
        },
        setAutoDateTime() {
            this.theReport.meetingDate = moment().format('DD/MM/YYYY HH:mm')
        },
        answerPoll() {
            this.$v.theReport.$touch()
            if (this.$v.theReport.$invalid) {
                toastr.error('Debe crear primero la reunión')
                return false
            }
            this.$bus.$emit('satisfaction-poll.open')
        },
        onSaveSatisfactionPoll() {
            this.$bus.$emit('satisfaction-poll.close')
            this.$bus.$emit('confirmation-message.close')
            this.$router.push({
                name: 'clientContactsPage',
                params: { clientId: this.clientId },
            })
        },
        cleanSatisfactionPoll() {
            this.$bus.$emit('satisfaction-poll.clean')
            this.$bus.$emit('confirmation-message.close')
            this.$router.push({
                name: 'clientContactsPage',
                params: { clientId: this.clientId },
            })
        },
        setCurrentDate() {
            this.theReport.meetingDate = moment().format('YYYY-MM-DD')
            this.theReport.meetingTime = moment().format('HH:mm:ss')
        },
    },
    created() {
        this.$bus.$on('close-this-pop-up', this.closePopupAddTask)
        this.$bus.$on('update', this.updateDraft)
        this.setCurrentDate()
    },
    mounted() {
        this.loadPetitionTypes()
        this.loadContacts()
        if (!this.isSave) {
            if (!!this.report) this.fillForm()
            else
                this.$router.push({
                    name: 'clientContactsPage',
                    params: { clientId: this.clientId },
                })
        }
        this.loadWatchers()
        //this.setAutoDateTime();
    },
}
</script>
